import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { withSetPropAction } from '../extensions/withSetPropAction';

/**
 * # Response
 *
 * Response을 설명하세요.
 */
// IPagination 타입을 MST 모델로 정의
const PaginationModel = types.model({
  page: types.number,
  size: types.number,
  offset: types.number,
  numberOfElements: types.number,
  totalElements: types.number,
  totalPages: types.number,
  first: types.boolean,
  last: types.boolean,
});
export const Response = types
  .model('Response')
  // --------------------------------------------------------------------------
  .props({
    resultCode: types.optional(types.maybeNull(types.string), null),
    // 성공 응답
    data: types.optional(types.maybeNull(types.frozen()), null),
    pagination: types.optional(types.maybeNull(PaginationModel), null),
    // 에러 응답
    errorCode: types.optional(types.maybeNull(types.string), null),
    title: types.optional(types.maybeNull(types.string), null),
    errorMessage: types.optional(types.maybeNull(types.string), null),
    details: types.optional(types.maybeNull(types.array(types.string)), null),
  })
  .actions(withSetPropAction)
  .actions((self) => ({
    resetResponseInfo: () => {
      self.resultCode = null;
      self.data = null;
      self.pagination = null;
      self.errorCode = null;
      self.title = null;
      self.errorMessage = null;
      self.details = null;
    },
    reset: () => {
      self.resultCode = null;
      self.data = null;
      self.pagination = null;
      self.errorCode = null;
      self.title = null;
      self.errorMessage = null;
      self.details = null;
    },
  }));

// --------------------------------------------------------------------------
type TResponse = Instance<typeof Response>;
type TResponseSnapshot = SnapshotOut<typeof Response>;

export interface IResponse extends TResponse {}
export type TResponseKeys = keyof TResponseSnapshot & string;
export interface IResponseSnapshot extends TResponseSnapshot {}
export const createResponse = () => types.optional(Response, {} as TResponse);
